import Icon from 'builder/components/Icon'
import { HandleWrapper } from './styles'
import { HandleRenderProps } from './types'

export const Handle = ({ disabled, style }: HandleRenderProps) => {
  return (
    <HandleWrapper style={style} disabled={disabled} data-testid="horizontal-slider-handle">
      {disabled && <Icon.Lock />}
    </HandleWrapper>
  )
}
